
export default {
  code: "id",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 7  // The week that contains Jan 1st is the first week of the year.
  },
  buttonText: {
    prev: "mundur",
    next: "maju",
    today: "hari ini",
    month: "Bulan",
    week: "Minggu",
    day: "Hari",
    list: "Agenda"
  },
  weekLabel: "Mg",
  allDayHtml: "Sehari<br/>penuh",
  eventLimitText: "lebih",
  noEventsMessage: "Tidak ada acara untuk ditampilkan"
};
